import { FETCH_CLUSTER_NUMBER_IDP_REQUEST,FETCH_CLUSTER_NUMBER_IDP_SUCCESS, FETCH_CLUSTER_NUMBER_IDP_FAILURE } from "./ClusterNumberTypes";
import APIManager from "../../ApiManager/ApiManager";

export const fetchClusterNumberIdpRequest=()=>{
    return{
        type:FETCH_CLUSTER_NUMBER_IDP_REQUEST
    };
}   
export const fetchClusterNumberIdpSuccess=(clusterNumberData)=>{
    return{
        type:FETCH_CLUSTER_NUMBER_IDP_SUCCESS,
        payload: clusterNumberData
    };
}   

export const fetchClusterNumberIdpFailure=(error)=>{
    return{
        type:FETCH_CLUSTER_NUMBER_IDP_FAILURE,
        payload: error
    };
}   
export const fetchClusterNumberIdp=(portfolioId)=>{
    return async (dispatch)=>{
        dispatch(fetchClusterNumberIdpRequest()); 
        try {
            const portfolioId = sessionStorage.getItem("portfolioId");
            const data = await APIManager.getClusterNumberIdp(portfolioId);
            dispatch(fetchClusterNumberIdpSuccess(data));
        } catch(error) {
            dispatch(fetchClusterNumberIdpFailure(error.message));
        }       
}
}  
        